import React, { useState, useEffect } from "react";
import Loading from "@/app/core/layouts/main/components/Loading";
import Storage from "@/app/core/util/Storage";
import { ToastContainer, toast } from "react-toastify";
import { GeneralHelper } from "@/app/core/util/helpers/GeneralHelper";
import MegaBanner from "../../dashboard/components/panels/MegaBanner";

export default function MainDashboard() {
  const userData = Storage.getUserData();
  const [loading] = useState(false);
  const enviroment = process.env.REACT_APP_ENV;

  useEffect(() => {
    loadAutomations();
  }, []);

  async function loadAutomations() {
    GeneralHelper.UpdateMetaTags("Home", "Plataforma para ajudá-lo a mediar reclamações com empresas no Rio")
    if (enviroment == "local" || enviroment == "staging") {
    }
  }

  return (
    <>
      <MegaBanner whats={true} whatsNumber={"5521996064765"} />
      <div className="p-3 bg-warning" style={{ marginTop: -40, zIndex:1 }}>
        <div className="row">

        <div className="col-4">
          <div className="">
            <div className="block-content text-center py-5">
              <img src={process.env.PUBLIC_URL + "/assets/media/megaphone.png"} />
            </div>
            <div className="mb-5 text-center font-size-sm">
              Busque a empresa desejada, Faça sua reclamação publicamente.
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="">
            <div className="block-content text-center py-5">
              <img src={process.env.PUBLIC_URL + "/assets/media/delivery.png"} />
            </div>
            <div className="mb-5 text-center font-size-sm">
              Notificaremos a empresa com sua reclamação sempre que possível.
            </div>
          </div>
        </div>
        <div className="col-4">
          <div className="">
            <div className="block-content text-center py-5">
              <img src={process.env.PUBLIC_URL + "/assets/media/deal.png"} />
            </div>
            <div className="mb-5 text-center font-size-sm">
              A empresa entra em contato com você por aqui para resolver o seu problema.
            </div>
          </div>
        </div>
        </div>
      </div>
      <Loading loading={loading} />
      <ToastContainer className="toastr" />
    </>
  );
}
